import React from "react";

export const FlightListItemSkeleton = () => {
    return (
        <li data-key="0" className="hw-search--flightFilterResult__listItem">
            <div className="hw-search--flightFilterResult__listItemList d-flex align-items-center hw-gapy10">
                <span className="hw-text14 d-flex align-items-center hw-gapy10">
                    <div style={{
                        width: '40px',
                        height: '40px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '50%',
                        flexShrink: 0,
                        animation: 'skeleton-pulse 1.5s infinite ease-in-out'
                    }} />
                    <div className="d-flex d-flex-column" style={{ gap: "6px" }}>
                        <div style={{
                            width: '120px',
                            height: '14px',
                            backgroundColor: '#f0f0f0',
                            borderRadius: '4px',
                            animation: 'skeleton-pulse 1.5s infinite ease-in-out'
                        }} />
                        <div style={{
                            width: '75px',
                            height: '12px',
                            backgroundColor: '#f0f0f0',
                            borderRadius: '4px',
                            animation: 'skeleton-pulse 1.5s infinite ease-in-out'
                        }} />
                    </div>
                </span>
            </div>

            <div className="hw-flight--listBox">
                <div className="destination s4">
                    <div className="destination-from">
                        <div style={{
                            backgroundColor: '#f0f0f0',
                            borderRadius: '4px',
                            width: '70px',
                            height: '14px',
                            marginBottom: '6px',
                            animation: 'skeleton-pulse 1.5s infinite ease-in-out'
                        }} />
                        <div style={{
                            backgroundColor: '#f0f0f0',
                            borderRadius: '4px',
                            width: '85px',
                            height: '22px',
                            marginBottom: '6px',
                            animation: 'skeleton-pulse 1.5s infinite ease-in-out'
                        }} />
                        <div style={{
                            backgroundColor: '#f0f0f0',
                            borderRadius: '4px',
                            width: '65px',
                            height: '12px',
                            animation: 'skeleton-pulse 1.5s infinite ease-in-out'
                        }} />
                    </div>
                    <div className="hw-flight--listBox__flight">
                        <div style={{
                            backgroundColor: '#f0f0f0',
                            borderRadius: '4px',
                            width: '60px',
                            height: '14px',
                            margin: '0 auto 8px',
                            animation: 'skeleton-pulse 1.5s infinite ease-in-out'
                        }} />
                        <div className="hw-flight--line">
                            <span className="circle" style={{ backgroundColor: '#e2e8f0' }} />
                            <span className="line" style={{ backgroundColor: '#e2e8f0' }} />
                            <span className="circle" style={{ backgroundColor: '#e2e8f0' }} />
                        </div>
                        <div style={{
                            marginTop: "8px",
                            backgroundColor: '#f0f0f0',
                            borderRadius: '4px',
                            width: '55px',
                            height: '12px',
                            margin: '8px auto 0',
                            animation: 'skeleton-pulse 1.5s infinite ease-in-out'
                        }} />
                    </div>
                    <div className="destination-to">
                        <div style={{
                            backgroundColor: '#f0f0f0',
                            borderRadius: '4px',
                            width: '70px',
                            height: '14px',
                            marginBottom: '6px',
                            animation: 'skeleton-pulse 1.5s infinite ease-in-out'
                        }} />
                        <div style={{
                            backgroundColor: '#f0f0f0',
                            borderRadius: '4px',
                            width: '85px',
                            height: '22px',
                            marginBottom: '6px',
                            animation: 'skeleton-pulse 1.5s infinite ease-in-out'
                        }} />
                        <div style={{
                            backgroundColor: '#f0f0f0',
                            borderRadius: '4px',
                            width: '65px',
                            height: '12px',
                            animation: 'skeleton-pulse 1.5s infinite ease-in-out'
                        }} />
                    </div>
                </div>

                <div className="hw-flight--listBoxAction">
                    <div style={{
                        backgroundColor: '#f0f0f0',
                        borderRadius: '4px',
                        width: '90px',
                        height: '24px',
                        marginBottom: '10px',
                        animation: 'skeleton-pulse 1.5s infinite ease-in-out'
                    }} />
                    <div style={{
                        width: '110px',
                        height: '36px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '6px',
                        marginBottom: '8px',
                        animation: 'skeleton-pulse 1.5s infinite ease-in-out'
                    }} />
                    <div style={{
                        width: '110px',
                        height: '14px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '4px',
                        animation: 'skeleton-pulse 1.5s infinite ease-in-out'
                    }} />
                </div>
            </div>
            <div className="justify-between d-flex hw-gapy10 align-items-center" style={{ marginTop: '12px', paddingTop: '10px', borderTop: '1px solid #f1f5f9' }}>
                <div style={{
                    width: '130px',
                    height: '14px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '4px',
                    animation: 'skeleton-pulse 1.5s infinite ease-in-out'
                }} />
                <div style={{
                    width: '90px',
                    height: '14px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '4px',
                    animation: 'skeleton-pulse 1.5s infinite ease-in-out'
                }} />
            </div>
        </li>
    );
};

export default FlightListItemSkeleton;
